import {
  allPass,
  anyPass,
  cond,
  T,
} from 'ramda';
import { computed, toValue } from 'vue';
import {
  hasCompanyPlan,
  hasUserPlan,
  isEmployee,
  isOwner,
  useGlobalState,
} from '@/store/user.store';
import router from '@/router/index';
import Trans from '@/i18n/translation';

export const goToHomeScreenFor = cond([
  [isEmployee, () => router.push(Trans.i18nRoute({ name: 'dashboard' }))],
  [isOwner, () => router.push(Trans.i18nRoute({ name: 'dashboard' }))],
  [T, () => router.push(Trans.i18nRoute({ name: 'home' }))],
]);

const { userState } = useGlobalState();

export const isUserLevelEmployee = computed(() => anyPass([isEmployee])(toValue(userState)));
export const isUserLevelOwner = computed(() => isOwner(toValue(userState)));

export const isUserOwnerOfCompanyPlan = computed(() => allPass([
  isOwner,
  hasCompanyPlan,
])(toValue(userState)));

export const isUserOwnerOfIndividualPlan = computed(() => allPass([
  isOwner,
  hasUserPlan,
])(toValue(userState)));
